var windowCallbacks = new Set();
var windowResizeHandler;

function createWindowResizeHandler() {
  windowResizeHandler = function windowResizeHandler() {
    var info = {
      get width() {
        return window.innerWidth;
      },

      get height() {
        return window.innerHeight;
      }

    };
    windowCallbacks.forEach(function (callback) {
      return callback(info);
    });
  };

  window.addEventListener("resize", windowResizeHandler);
}

function resizeWindow(callback) {
  windowCallbacks.add(callback);
  if (!windowResizeHandler) createWindowResizeHandler();
  return function () {
    windowCallbacks.delete(callback);

    if (!windowCallbacks.size && typeof windowResizeHandler === "function") {
      window.removeEventListener("resize", windowResizeHandler);
      windowResizeHandler = undefined;
    }
  };
}

export { resizeWindow };